var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-modal", {
    attrs: {
      "has-header": "",
      "has-footer": "",
      footerButtonsOnRight: "",
      open: _vm.isOpen,
    },
    on: { close: () => _vm.$emit("onClose") },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "h2",
              { staticClass: "emd-text _size_section _color_contrast" },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("modal.boleto-stone.modal-disable.title")) +
                    " "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _vm.error
              ? _c(
                  "emd-alert",
                  {
                    attrs: {
                      variant: "danger",
                      title: _vm.$t("account.settings.alert.error-title"),
                    },
                    on: {
                      cancel: function ($event) {
                        _vm.error = null
                      },
                    },
                  },
                  [
                    _c("template", { slot: "content" }, [
                      _vm._v(" " + _vm._s(_vm.error) + " "),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
            _c("p", { staticClass: "emd-text _color_subtle" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("modal.boleto-stone.modal-disable.paragraph-1.first")
                  ) +
                  " "
              ),
              _c("strong", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "modal.boleto-stone.modal-disable.paragraph-1.second"
                      )
                    ) +
                    " "
                ),
              ]),
            ]),
            _c("br"),
            _c("p", { staticClass: "emd-text _color_subtle" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("modal.boleto-stone.modal-disable.paragraph-2")
                  ) +
                  " "
              ),
            ]),
            _c("password-confirmation", {
              staticClass: "eu-mt_2",
              attrs: {
                label: _vm.$t("modal.password.type-password"),
                value: _vm.password,
              },
              on: { input: _vm.onChangePassword },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "emd-button",
              {
                attrs: {
                  size: "big",
                  color: "danger",
                  type: "outline",
                  disabled: _vm.isLoad,
                },
                on: { click: () => _vm.$emit("onClose") },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("modal.boleto-stone.modal-disable.button-cancel")
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "emd-button",
              {
                attrs: {
                  size: "big",
                  color: "danger",
                  disabled: _vm.isLoad || !_vm.password,
                },
                on: { click: _vm.onDisable },
              },
              [
                _vm.isLoad
                  ? _c("emd-loader", { attrs: { type: "" } })
                  : _vm._e(),
                !_vm.isLoad
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "modal.boleto-stone.modal-disable.button-disable"
                            )
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }